import { render } from "./ProfTipoRelatorio.vue?vue&type=template&id=21e547bf&scoped=true"
import script from "./ProfTipoRelatorio.vue?vue&type=script&lang=js"
export * from "./ProfTipoRelatorio.vue?vue&type=script&lang=js"

import "./ProfTipoRelatorio.vue?vue&type=style&index=0&id=21e547bf&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e547bf"]])

export default __exports__